/* eslint-disable class-methods-use-this */
import ElementDataStore from "./store";

class ElementDataManager {
  constructor(reduxStore) {
    this.store = {};
    this.reduxStore = reduxStore;
  }

  getReduxState() {
    return this.reduxStore.getState();
  }

  currentUser() {
    return this.reduxStore.getState().user;
  }

  createStore(initialData) {
    return new ElementDataStore(initialData);
  }

  get(element) {
    return this.store[element];
  }

  update(element, data) {
    if (!this.store[element]) {
      this.register(element, data);
    }
    this.store[element].update(data);
  }

  register(element, data = {}) {
    if (this.store[element]) {
      return;
    }
    this.store[element] = this.createStore(data);
  }
}

export default ElementDataManager;
